// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.singleSelectOptWrapper{
    max-height: 13.5rem;
    overflow: hidden;
    padding-bottom: 0.5rem;
}
.singleSelectOpt {
    width: inherit;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.singleSelectAddToListNAcontainer{
    display: flex;
    flex-wrap: wrap;
}
@media (orientation: landscape){
    .singleSelectOptWrapper{
        max-height: 6.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/fields/userInput/singleSelect/styles.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".singleSelectOptWrapper{\n    max-height: 13.5rem;\n    overflow: hidden;\n    padding-bottom: 0.5rem;\n}\n.singleSelectOpt {\n    width: inherit;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n.singleSelectAddToListNAcontainer{\n    display: flex;\n    flex-wrap: wrap;\n}\n@media (orientation: landscape){\n    .singleSelectOptWrapper{\n        max-height: 6.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
